import { THUMBNAIL } from "@/lib/constants/shared";
import { AiFillPicture } from "react-icons/ai";

interface LibraryItemCardProps {
  name: string;
  imageUrl?: string | null | undefined;
  subtitle: string;
  /** Shown under the subtitle in place of a card nobody can open: why it is unusable. */
  blockedReason?: string | undefined;
  onClick: () => void;
}

/** Read-only counterpart to ProjectCard/LessonCard: thumbnail and name, nothing editable. */
export function LibraryItemCard({
  name,
  imageUrl,
  subtitle,
  blockedReason,
  onClick,
}: LibraryItemCardProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={Boolean(blockedReason)}
      title={blockedReason}
      className={`app-card overflow-hidden text-left ${
        blockedReason ? "cursor-not-allowed opacity-60" : "app-card-link"
      }`}
    >
      <span
        className={`${THUMBNAIL.projectAspectRatioClass} flex items-center justify-center overflow-hidden border-b border-gray-100 ${
          imageUrl ? "bg-white" : "bg-app-sky-soft"
        }`}
      >
        {imageUrl ? (
          <img src={imageUrl} alt={name} className="h-full w-full object-cover" />
        ) : (
          <AiFillPicture className="h-10 w-10 text-app-ink/30" aria-hidden="true" />
        )}
      </span>

      <span className="block p-3">
        <span className="block truncate font-kumbh font-bold text-app-ink">{name}</span>
        <span className="app-label mt-0.5 block">{subtitle}</span>
        {blockedReason && (
          <span className="caption mt-0.5 block text-app-overdue">{blockedReason}</span>
        )}
      </span>
    </button>
  );
}
